<template>
  <div class="form-detail">
    <div class="d-flex justify-content-between">
      <h1>Thông tin lô hàng</h1>
      <button class="btn btn-primary mb-2" style="width: 200px" @click="openAddModal">
        LK Sim với TingBox
      </button>
    </div>

    <div v-if="data.length > 0">
      <div style="display: flex; flex-direction: column; gap: 5px">
        <div class="card p-1" v-for="(dataPerent, index) in data || []" :key="index">
          <div class="mb-2">
            <Content title="Tên người gửi" :content="dataPerent?.senderName"></Content>
            <Content title="Mã theo dõi" :content="dataPerent?.trackingCode"></Content>
            <Content title="Ghi chú" :content="dataPerent?.notes"></Content>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Tên thiết bị</th>
                <th scope="col">serial</th>
                <th scope="col">Mã thiết bị</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="dataPerent?.devices || []">
                <tr v-for="(item, index) in dataPerent.devices" :key="index">
                  <td>
                    {{ item.deviceName }}
                  </td>
                  <td>
                    {{ item.serial }}
                  </td>
                  <td>
                    {{ item.deviceCode }}
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="3">
                    <div class="text-center text-muted">
                      {{ isLoading ? 'Đã lấy dữ liệu...' : 'Không có dữ liệu' }}
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else class="text-center">Không có dữ liệu</div>

    <AddSimTingboxModal
      :visible.sync="showAddModal"
      :inventory-options="optionInventory"
      :tingbox-type-options="optionType"
      :sim-type-options="optionTypeSim"
      :get-tingbox-devices="getTingboxDevicesByType"
      :get-sim-devices="getSimDevicesByType"
      @success="handleModalSuccess"
      @error="handleModalError"
      @close="handleModalClose"
    />
  </div>
</template>

<script>
  import Content from '@/components/common/Content.vue'
  import { MerchantService } from '@/services/merchant.service'
  import { showMess } from '@/config/utils'
  import AddSimTingboxModal from './AddSimTingboxModal.vue'

  export default {
    name: 'DeviceShipments',

    components: { Content, AddSimTingboxModal },

    props: {
      customerId: {
        type: String,
      },
      type: {
        type: String,
        default: 'customer',
      },
    },

    data() {
      return {
        data: [],
        isLoading: false,
        showAddModal: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
      }
    },

    computed: {
      optionType() {
        const tingboxDevices = this.getTingboxDevices()
        const uniqueDeviceCodes = [...new Set(tingboxDevices.map(device => device.deviceCode))]

        return uniqueDeviceCodes.map(code => ({
          id: code,
          text: this.getDeviceNameByCode(code),
        }))
      },

      // Generate SIM options from fetchData response
      optionTypeSim() {
        const simDevices = this.getSimDevices()
        const uniqueDeviceCodes = [...new Set(simDevices.map(device => device.deviceCode))]

        return uniqueDeviceCodes.map(code => ({
          id: code,
          text: this.getDeviceNameByCode(code),
        }))
      },

      // Generate inventory options (using sender info)
      optionInventory() {
        const senders = [
          ...new Set(
            this.data.map(item => ({
              id: item.senderId,
              name: item.senderName,
            }))
          ),
        ]

        return [
          { id: '0', text: 'Tất cả' },
          ...senders.map(sender => ({
            id: sender.id,
            text: sender.name,
          })),
        ]
      },
    },

    created() {
      if (this.customerId) {
        this.fetchData()
      }
    },

    methods: {
      openAddModal() {
        this.showAddModal = true
      },

      // Handle modal success event
      handleModalSuccess(message) {
        console.log('Success:', message)
        this.showSuccessMx(message)
        this.fetchData() // Refresh the data
      },

      // Handle modal error event
      handleModalError(message) {
        console.log('Error:', message)
        this.showErrorMx(message)
      },

      // Handle modal close event
      handleModalClose() {
        this.showAddModal = false
      },

      // Success message method
      showSuccessMx(message) {
        showMess(this, 'Thành công', message, 'success', 'b-toaster-top-right', 5000)
      },

      // Error message method
      showErrorMx(message) {
        showMess(this, 'Lỗi', message, 'danger', 'b-toaster-top-right', 5000)
      },

      // Helper methods to extract device data
      getTingboxDevices() {
        const allDevices = this.data.flatMap(item => item.devices || [])
        return allDevices.filter(device =>
          [
            'TingBox02',
            'TingBox01',
            'TingBox',
            'TingBoxS',
            'TingBoxPRO',
            'TingBoxS2',
            'TingBoxS3',
            'TingBoxP1',
          ].includes(device.deviceCode)
        )
      },

      getSimDevices() {
        const allDevices = this.data.flatMap(item => item.devices || [])
        return allDevices.filter(device => device.deviceCode && device.deviceCode.startsWith('SIM'))
      },

      getDeviceNameByCode(deviceCode) {
        const allDevices = this.data.flatMap(item => item.devices || [])
        const device = allDevices.find(d => d.deviceCode === deviceCode)
        return device ? device.deviceName : deviceCode
      },

      // Get TingBox devices by type for modal
      getTingboxDevicesByType(deviceCode) {
        return this.getTingboxDevices()
          .filter(device => device.deviceCode === deviceCode)
          .map(device => ({
            id: device.serial,
            text: device.serial,
          }))
      },

      // Get SIM devices by type for modal
      getSimDevicesByType(deviceCode) {
        return this.getSimDevices()
          .filter(device => device.deviceCode === deviceCode)
          .map(device => ({
            id: device.serial,
            text: device.serial,
          }))
      },

      async fetchData() {
        try {
          this.isLoading = true
          let data = null

          if (this.type === 'lead') {
            data = await MerchantService.getDataMerchantLeadId({
              leadId: this.customerId,
            })
          } else {
            data = await MerchantService.getDataMerchantByCustomerId({
              customerId: this.customerId,
            })
          }

          if (data?.success) {
            this.data = data.data
          } else {
            showMess(this, 'Error', data.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (error) {
          showMess(this, 'Error', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style lang="css" scoped>
  .table {
    thead {
      tr {
        background: #ddd;
        border: 1px solid #ccc;

        th {
          font-weight: 600;
          color: #0b62ab;
          border-left: 1px solid #ccc;

          &:first-child {
            border-left: none;
          }
        }
      }
    }

    tbody {
      tr {
        td {
          ul {
            padding-left: 0;

            li {
              display: inline-block;
              border: 1px solid #ddd;
              width: 80px;
              height: 60px;
              overflow-y: hidden;

              a {
                img {
                  width: 80px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
